import { useState, useEffect, useRef } from 'react'
import { useTableStore, useTableMetadataStore } from '../../_stores'
import PaginationButton from './_PaginationButton'

function Pagination({ className, url, offsetQueryParameter, lengthQueryParameter, onPaginate, onLoad, willFetch = true }, ref) {
	const setSelectedRows = useTableMetadataStore(state => state.setSelectedRows)

	const [offset, setOffset] = useState(0)
	const [length, setLength] = useState(100)
	const [totalPageNumber, setTotalPageNumber] = useState(0)
	const [paginationElements, setPaginationElements] = useState([])
	const [activePage, setActivePage] = useState(0)
	const [totalRecords, setTotalRecords] = useState(0)
	const lengthOptions = [20, 30, 50, 100, 250, 300]
	const [isFetching, setIsFetching] = useState(false)

	if (!ref) ref = useRef(null)

	const setTableData = useTableStore(state => state.setTableData)
	const tableData = useTableStore(state => state.tableData)

	const setIsTableLoading = useTableStore(state => state.setIsTableLoading)
	const changePage = (e) => {
		setOffset(+e.target.dataset.value * length)
		onPaginate?.(+e.target.dataset.value * length)
	}

	const fetchData = async (fetchCurrentPage) => {
		setIsFetching(true)
		setSelectedRows([])

		const response = await fetch(`${url}&${offsetQueryParameter}=${offset}&${lengthQueryParameter}=${length}`, {
			"headers": window.HEADER_OBJ
		})

		const data = await response.json()
		const totalRecords = data.recordsFiltered
		
		
		setIsFetching(false)
		setTableData(data.data)
		setTotalRecords(totalRecords)
		setTotalPageNumber(Math.ceil(totalRecords / length))
		setActivePage(Math.ceil(offset / length))
		
		ref.current.onLoad && ref.current.onLoad(data)
	}

	const createDots = (key) => {
		return <span key={key} className='!px-0 hover:!cursor-auto hover:!text-grey-text'>...</span>
	}

	const createPageNumber = (key) => {
		return <span key={key} data-value={key} onClick={changePage} className={`${key === activePage ? 'bg-primary text-white' : ''} text-grey-text border-none text-15px min-w-0 py-1.5 px-3 rounded-primary mx-1 animation-pop`}>{key + 1}</span>
	} 

	useEffect(() => {
		ref.current.fetchData = fetchData
		ref.current.isFetching = isFetching
		ref.current.onLoad = onLoad

		if (isFetching) {
			setIsTableLoading(true)
		} else {
			setIsTableLoading(false)
		}
	}, [ref, fetchData, isFetching, onLoad])



	useEffect(() => {
		let arr = []
		let maxElement = 5
		// key and value are 0-indexed
		if (totalPageNumber > maxElement) {

			if (activePage <= maxElement - 2) {
				for (let i = 0; i < maxElement; i++) {
					arr.push(createPageNumber(i))
				}

				arr.push(createDots(maxElement + activePage + 1))
				arr.push(createPageNumber(totalPageNumber - 1))

			} else if (activePage <= totalPageNumber - maxElement) { // 6 - 13563
				let half = Math.floor(maxElement / 2)

				arr.push(createPageNumber(0))
				arr.push(createDots(1))

				for (let i = activePage - half; i <= activePage + half; i++) {
					arr.push(createPageNumber(i))
				}

				arr.push(createDots(maxElement + activePage + 1))
				arr.push(createPageNumber(totalPageNumber - 1))
			} else {
				arr.push(createPageNumber(0))
				arr.push(createDots(1))

				for (let i = totalPageNumber - maxElement; i < totalPageNumber; i++) {
					arr.push(createPageNumber(i))
				}
			}

		} else {
			for (let i = 0; i < totalPageNumber; i++) {
				arr.push(createPageNumber(i))
			}
		}

		setPaginationElements(arr)
	}, [totalPageNumber, activePage])

	useEffect(() => {
		if (willFetch) {
			fetchData()
		}
	}, [offset, length, url])

	return (
		<div className={`flex items-center justify-between ${className ?? ''}`} ref={ref}>
			<div className='flex items-center gap-5'>
				<select name="" id="" className='rounded-primary border-normal border-grey p-1 pl-2 pr-11' defaultValue={length} onChange={(e) => {
					setLength(Number(e.target.value))
				}}>
					{
						lengthOptions.map((option, index) => <option key={index} value={option}>{option}</option>)
					}
				</select>
				<p className='font-medium py-0 text-sm'>Showing {(offset + 1).toLocaleString()} to {offset + length > totalRecords ? totalRecords.toLocaleString() : (offset + length).toLocaleString()} of {totalRecords.toLocaleString()} entries</p>
			</div>
			<div className='text-black flex items-center [&>span]:text-2xl [&>span]:font-MaterialIconsNew
			[&_span]:transition-all
			[&_span:hover]:text-primary [&_span:hover]:cursor-pointer'>
				<PaginationButton handleClick={changePage} value={0} disabled={activePage === 0} icon="first_page" />
				<PaginationButton handleClick={changePage} value={activePage - 1} disabled={activePage === 0} icon="chevron_backward" />

				<div className='flex items-center text-[#ABAFB3] gap-2 [&>span]:px-3.5 text-15px font-bold'>
					{paginationElements}
				</div>

				<PaginationButton handleClick={changePage} value={activePage + 1} disabled={activePage === totalPageNumber - 1} icon="chevron_forward" />
				<PaginationButton handleClick={changePage} value={totalPageNumber - 1} disabled={activePage === totalPageNumber - 1} icon="last_page" />
			</div>
		</div>
	)
}

export default React.forwardRef(Pagination)